module.exports = __webpack_public_path__ + "img/iz-registra-zig.203c6e20.svg";